import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

export const StyledCardSubHeadingText = styled(Text)`
    font-size: 16px;
    line-height: 22px;
`;

export const StyledVisitsChangeIcon = styled(SWReactIcons)`
    display: flex;
    align-items: center;
`;

export const StyledSingleDomainViewContainer = styled(Flex)`
    & > span[data-automation="table-cell"] {
        width: 100%;
    }
`;

export const StyledTableContainer = styled.div`
    padding-top: 8px;

    & .ant-table-body {
        border-bottom: 1px solid ${colorsPalettes.carbon[100]};

        & .ant-table-tbody > tr:last-child > td {
            border: none;
        }

        .ant-table-cell-row-hover {
            background-color: ${colorsPalettes.carbon[0]} !important;
        }
    }

    & .ant-table-tbody .ant-table-row {
        & .ant-table-cell {
            padding-top: 15px !important;
            padding-bottom: 15px !important;
        }
    }

    & .ant-table-thead {
        & > tr:first-of-type {
            & th.ant-table-cell {
                background-color: ${colorsPalettes.carbon[0]};
            }

            & th.ant-table-cell > span:last-child {
                height: 100%;
            }
        }

        & > tr:last-of-type {
            & th.ant-table-cell {
                &:hover {
                    background-color: ${colorsPalettes.carbon[25]} !important;
                }
            }

            & th.ant-table-cell:last-child {
                padding-left: 0 !important;
            }
        }
    }
`;

export const StyledExternalLink = styled.a`
    text-decoration: none;
    ${setFontVariant("chip1", colorsPalettes.blue["400"])}
    display: block;
    margin: 4px 0;
`;

export const StyledTabBarWrapper = styled.div`
    [role="tablist"] {
        display: flex;
    }

    [role="tab"] {
        flex: 1 0 0;
        justify-content: center;
        height: 48px;
    }
`;

export const StyledUpgradeIcon = styled.span`
    display: inline-flex;
    align-items: center;
`;
